import { render, staticRenderFns } from "./userQuestion.vue?vue&type=template&id=a1402efc&"
import script from "./userQuestion.vue?vue&type=script&lang=js&"
export * from "./userQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports